import { MARQUEE_ITEMS } from "@/data";

export default function Marquee() {
  const row = [...MARQUEE_ITEMS, ...MARQUEE_ITEMS];
  return (
    <div data-testid="editorial-marquee" className="overflow-hidden border-y border-slate-200 bg-white py-5">
      <div className="animate-marquee flex w-max items-center whitespace-nowrap">
        {[0, 1].map((half) => (
          <div key={half} className="flex items-center" aria-hidden={half === 1}>
            {row.map((item, i) => (
              <span key={`${half}-${i}`} className="flex items-center">
                <span className="font-serif text-2xl font-medium italic tracking-tight text-slate-800 sm:text-3xl">
                  {item}
                </span>
                <span className="mx-8 text-sky-600 sm:mx-12">◆</span>
              </span>
            ))}
          </div>
        ))}
      </div>
    </div>
  );
}
